import { useEffect } from 'react';

import { BrowserRouter as Router, Route } from 'react-router-dom';
import i18next from 'i18next';

import useAuthentication from 'application/authentication/useAuthentication';
import UseScrollToTop from 'hooks/useScrollToTop';
import Guest from 'layout/Guest/Guest';
import User from 'layout/User/User';
import 'translations/i18n';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

import 'react-quill/dist/quill.snow.css';
import './style/App.scss';

function App() {
  const { isLoading, user, getCurrentUser } = useAuthentication();

  useEffect(() => {
    const lang = localStorage.getItem('lang');
    i18next.changeLanguage(lang);
    getCurrentUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <UseScrollToTop>
        <div className="App">{<Route path="/" render={() => (user ? <User /> : <Guest />)} />}</div>
      </UseScrollToTop>
    </Router>
  );
}

export default App;
